import { render, staticRenderFns } from "./TokenPayoutDetail.vue?vue&type=template&id=bcc7e752&"
import script from "./TokenPayoutDetail.vue?vue&type=script&lang=js&"
export * from "./TokenPayoutDetail.vue?vue&type=script&lang=js&"
import style0 from "./TokenPayoutDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports